
      function oneTrustbtn() { 
      const privacyDiv = document.getElementById('onetrust-pc-sdk');
      if(privacyDiv){privacyDiv.classList.remove('ot-slide-out-left','ot-fade-in');
      privacyDiv.style='display:block !important;'};
      }


       /*Rebuy rebuy:cart.remove listener*/
  document.addEventListener('rebuy:smartcart.line-item-removed', function(e) {
    const { item } = e.detail;
    console.log("rebuy:smartcart.line-item-removed", item);
    window.removedItem = item;
    Shopify.analytics.publish('rebuy:product_removed_from_cart', {
      product_id: item.product_id,
      product_name: item.product_title,
      price: item.price/100,
      currency: 'USD',
      quantity: item.quantity
    });
  });
   document.addEventListener('DOMContentLoaded', function() {
    const productGrid = document.querySelector('.product-grid');
    if (productGrid) {
    const observerGrid = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            if(!!!window.filterTimeout){
            observerGrid.disconnect();
            window.filterTimeout = setTimeout(()=>{
                observerGrid.observe(productGrid, {
                childList: true,   // watch for added/removed nodes
                subtree: false      // include deeper descendants
                });
                if (
                    window.yotpoWidgetsContainer &&
                    typeof window.yotpoWidgetsContainer.initWidgets === 'function'
                    ) {
                    try {
                        window.yotpoWidgetsContainer.initWidgets();
                    } catch (err) {
                        console.warn('[Yotpo] initWidgets failed:', err);
                    }
                    }
                window.filterTimeout =  null;
            },1000);
            break;
            }
        }
        }
    });
    observerGrid.observe(productGrid, {
        childList: true,   // watch for added/removed nodes
        subtree: false      // include deeper descendants
    });
    }
    /*YotpoWidget Observer End*/
    /*Filter blocked fix*/
    const filterDrawer = document.querySelector('.facets--drawer');
    if (filterDrawer){
    const filterDrawerObserver = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            console.log('mutation',filterDrawer);
            if(filterDrawer.open){
            filterDrawer.inert = false;
            filterDrawer.style.opacity = '1';
            filterDrawer.style.pointerEvents = '';
            }
        }
        }
    });
    filterDrawerObserver.observe(filterDrawer, {
        attributes: true,     
        attributeFilter: ['open'],
    });
    }
  });
   
   
  /*Filter blocked fix end*/

  //Klaviyo onclick code
   (function () {
    function extractFormId(href) {
      if (!href) return null;

      const hashPos = href.indexOf("#");
      if (hashPos === -1) return null;

      const hash = href.slice(hashPos + 1); // remove '#'
      const prefix = "klaviyo-open-form-";
      if (!hash.startsWith(prefix)) return null;

      // allow alphanumeric IDs like Rjvt6j
      return hash.slice(prefix.length).trim();
    }

    function openKlaviyoForm(formId) {
      if (!formId) return;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", formId]);
    }

    // Click on link (your linked banner image)
    document.addEventListener("click", function (e) {
      if (e.defaultPrevented) return;
      const a = e.target.closest && e.target.closest("a[href*='#klaviyo-open-form-']");
      if (!a) return;

      const formId = extractFormId(a.getAttribute("href"));
      if (!formId) return;

      e.preventDefault();
      openKlaviyoForm(formId);
    });

    // Optional: if someone lands on a URL with that hash (email/ads), open immediately
    if (location.hash && location.hash.indexOf("#klaviyo-open-form-") === 0) {
      const formId = extractFormId(location.href);
      openKlaviyoForm(formId);

      // Clean up hash so refresh/back doesn't keep reopening
      history.replaceState(null, document.title, location.pathname + location.search);
    }
  })();
  

  window.fermat = window.fermat ||    function () {(window.fermat.q = window.fermat.q || []).push(arguments[0]);};
    (function () {
     var script = document.createElement("script");
     script.src = "https://static.clairedefermat.com/pixel/v2/pixel.js";
     script.async = true;
     var firstScript = document.getElementsByTagName("script")[0];
     firstScript.parentNode.insertBefore(script, firstScript);
    })();

   var _fermatInited = false;
    var _fermatRetries = 0;
    var MAX_RETRIES = 20; // 20 × 500ms = 10 s max wait
 
    function initFermatWrapper() {
      if (_fermatInited) return;                        // already done, bail
      if (_fermatRetries >= MAX_RETRIES) {
        console.warn('[Fermat] customerPrivacy not ready after 10 s, giving up');
        return;
      }
      if (window.Shopify && window.Shopify?.customerPrivacy) {
        //console.log('[Fermat] Validate Customer Privacy', Shopify.customerPrivacy);
        if (window.Shopify.customerPrivacy.getTrackingConsent() === 'yes') {
          window.fermat({ method: "init", config: {
            id: "www-proactiv-com",
            //debug: { debugLogging: true }
          }});
          _fermatInited = true;                        // stop any future retries
        }
        // consent was 'no' or 'unknown' — don't retry, wait for the event
      } else {
        _fermatRetries++;
        setTimeout(initFermatWrapper, 500);
      }
    }
    initFermatWrapper();
 
    document.addEventListener("visitorConsentCollected", function() {
      if (!_fermatInited) {
        _fermatRetries = 0;                            // reset so event path gets retries
        initFermatWrapper();
      }
    });